import React, { useState } from "react";
import {useDispatch, useSelector} from "react-redux";
import {Button, Modal} from "react-bootstrap";
import Dropdown from "../Dropdown";
import {toast} from "react-toastify";
import {
    setEditFixedAssetRecord,
    setNewFixedAssetRecord
} from "../../../_reducers/DataPanel/FixedAssets/fixedAssetsSlice";

const FixedAssetRecordQuickEdit = ({data, title = "Quick Edit"}) => {
    const dispatch = useDispatch();
    const [show, setShow] = useState(false);
    const [assetData, setAssetData] = useState(data);

    const TABS_DATA = useSelector((state) => state.TABS_REDUCER);
    const ACTIVE_MAIN_TAB = useSelector((state) => state.ACTIVE_MAIN_TAB);
    const FIXED_ASSETS = useSelector((state) => state.FIXED_ASSETS);

    const isInView = TABS_DATA[ACTIVE_MAIN_TAB].tabType === "edit-fixed-asset-record" && FIXED_ASSETS.editFixedAssetRecord?.myDataStatus === "sent";
    const isRequired = false;

    const getFixedAssetObject = () => {
        if (TABS_DATA[ACTIVE_MAIN_TAB].tabType === "edit-fixed-asset-record") {
            return FIXED_ASSETS.editFixedAssetRecord;
        } else {
            return FIXED_ASSETS.newFixedAssetRecord;
        }
    }

    const saveClicked = () => {
        const cloneAssets = structuredClone(getFixedAssetObject().fixedAssets);
        const findMatching = cloneAssets.find((el) => el._id === assetData._id);
        if (findMatching) {
            findMatching.classificationCategory = assetData.classificationCategory;
            findMatching.classificationType = assetData.classificationType;
            if (TABS_DATA[ACTIVE_MAIN_TAB].tabType === "edit-fixed-asset-record") {
                dispatch(setEditFixedAssetRecord({...FIXED_ASSETS.editFixedAssetRecord, fixedAssets: cloneAssets}));
            } else {
                dispatch(setNewFixedAssetRecord({...FIXED_ASSETS.newFixedAssetRecord, fixedAssets: cloneAssets}));
            }
            setShow(false);
            toast.success("Επιτυχής αποθήκευση.");
        }
    }

    const handleOnChange = (e, type, name) => {
        if (type === "dropdown") {
            if (e.value !== assetData[name]) {
                const copyData = {...assetData};
                if (name === "classificationCategory") {
                    copyData["classificationCategory"] = e.value;
                    copyData["classificationType"] = "";
                } else if (name === "classificationType") {
                    copyData["classificationType"] = e.value;
                }
                setAssetData(copyData);
            }
        }
    }

    const categoryOptions = [
        {
            value: "category2_8",
            label: "Αποσβέσεις Παγίων",
            type: [
                {
                    value: "E3_587",
                    label: "Αποσβέσεις"
                },
            ]
        },
        {
            value: "category2_95",
            label: "Λοιπά πληροφοριακά Στοιχεία Εξόδων (+)/ (-)",
            type: [
                {
                    value: "null",
                    label: "Δεν ενημερώνει Ε3"
                },
            ]
        }
    ]

    const invalidAsset = assetData.classificationCategory === "" || assetData.classificationType === "";

    return (
        <React.Fragment>
            <Button style={{pointerEvents: "auto"}} size={"sm"} variant={"default"} title={title} onClick={() => setShow(true)}>
                <i id={assetData.no} className="far fa-edit"></i>
            </Button>

            <Modal backdrop={"static"} show={show} onHide={() => setShow(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>{isInView ? "Προβολή" : "Τροποποίηση"} Παγίου</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Dropdown
                        name={"quickEditCategory"}
                        label={"Κατηγορία My Data"}
                        options={categoryOptions}
                        key={Math.random()}
                        required={isRequired}
                        disabled={isInView}
                        defaultValue={categoryOptions.find((el) => el.value === assetData.classificationCategory)}
                        onChange={(e) => handleOnChange(e, "dropdown", "classificationCategory")}
                    />
                    <Dropdown
                        name={"quickEditType"}
                        label={"Τύπος My Data"}
                        options={assetData.classificationCategory ? categoryOptions.find((el) => el.value === assetData.classificationCategory).type : []}
                        key={Math.random()}
                        required={isRequired}
                        disabled={isInView}
                        defaultValue={assetData.classificationCategory ? categoryOptions.find((el) => el.value === assetData.classificationCategory).type.find((el) => el.value === assetData.classificationType) : []}
                        onChange={(e) => handleOnChange(e, "dropdown", "classificationType")}
                    />
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="outline-primary" onClick={() => setShow(false)}>Κλείσιμο</Button>
                    {!isInView && (
                        <Button variant="primary" onClick={() => saveClicked()} disabled={invalidAsset}>Αποθήκευση</Button>
                    )}
                </Modal.Footer>
            </Modal>
        </React.Fragment>
    )
}

export default FixedAssetRecordQuickEdit;
